<template>
    <div id="editar-personales">
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="18" class="titulo">
                Editar Datos Personales
            </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="22" class="cuerpo">

                <v-alert v-if="estado" type="success" color="green" style="margin-bottom:30px" :value="true">
                    Los Cambios se Guardaron Correctamente.
                </v-alert>
                <v-alert v-if="error" type="error" color="red" style="margin-bottom:30px" :value="true">
                    Ha ocurrido un error intentando procesar su solicitud.<br>Por favor, intente nuevamente.
                </v-alert>
                <v-alert v-if="datospersonales.Nacimiento=='00/00/0000'" type="error" color="red" style="margin-bottom:30px" :value="true">
                    Por favor ingrese una Fecha de Nacimiento Válida.
                </v-alert>
                <v-alert v-if="datospersonales.Sexo==''" type="error" color="red" style="margin-bottom:30px" :value="true">
                    Por favor ingrese un Sexo Válido.
                </v-alert>


                <!-- DATOS PERSONALES Y DE CONTACTO -->
                <el-form ref="fp" :model="datospersonales" :rules="rules_fp">
                    <el-row :gutter="20" justify="space-between">
                        <el-col :xs="24" :sm="12">
                            <center><strong>Datos Personales</strong></center><br>
                            <el-form-item label="DNI">
                                <el-input type="text" v-model="datospersonales.DNI" maxlength="8" readonly=""></el-input>
                            </el-form-item>
                            <el-form-item label="Pre CUIL" prop="pre_cuil">
                                <el-input type="text" v-model="datospersonales.pre_cuil" maxlength="2" @paste.prevent @keypress.native="control($event, 'n')"></el-input>
                            </el-form-item>
                            <el-form-item label="Pos CUIL" prop="pos_cuil">
                                <el-input type="text" v-model="datospersonales.pos_cuil" maxlength="1" @paste.prevent @keypress.native="control($event, 'n')"></el-input>
                            </el-form-item>
                            <el-form-item label="Apellido/s" prop="Apellido">
                                <el-input type="text" ref="Apellido" v-model="datospersonales.Apellido" @paste.prevent @keypress.native="control($event, 't')"></el-input>
                            </el-form-item>
                            <el-form-item label="Nombre/s" prop="Nombre">
                                <el-input type="text" v-model="datospersonales.Nombre" @paste.prevent @keypress.native="control($event, 't')"></el-input>
                            </el-form-item>
                            <el-form-item label="Fecha de Nacimiento" prop="Nacimiento">
                                <el-date-picker
                                    v-model="datospersonales.Nacimiento"
                                    type="date"                                    
                                    placeholder="dd/mm/aaaa"
                                    format="dd/MM/yyyy"
                                    value-format="dd/MM/yyyy"
                                    style="width:100%"
                                    @paste.prevent>
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="Sexo" prop="Sexo">
                                <el-select class="el-col el-col-24" v-model="datospersonales.Sexo" placeholder="Seleccione" required style="padding:0px !important">
                                    <el-option
                                        v-for="(item, index) in Sexos"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.value"
                                        @paste.prevent>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Provincia" prop="Provincia">
                                <el-select class="el-col el-col-24" v-model="datospersonales.Provincia" placeholder="Seleccione" required style="padding:0px !important">
                                    <el-option
                                        v-for="(item, index) in Provincias"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.value"
                                        @paste.prevent>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Localidad" prop="Localidad">
                                <el-select class="el-col el-col-24" v-model="datospersonales.Localidad" placeholder="Seleccione" required style="padding:0px !important">
                                    <el-option
                                        v-for="(item, index) in Localidades"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.value"
                                        @paste.prevent>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Título Profesional" prop="Titulo_profesional">
                                <el-input type="text" v-model="datospersonales.Titulo_profesional" @paste.prevent @keypress.native="control($event, 't')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <center><strong>Datos de Contacto</strong></center><br>
                            <el-form-item label="Mail" prop="Mail">
                                <el-input type="email" v-model="datospersonales.Mail" @paste.prevent required @keypress.native="control($event, 'm')"></el-input>
                            </el-form-item>
                            <el-form-item label="Teléfono" prop="Telefono">
                                <el-input type="text" v-model="datospersonales.Telefono" @paste.prevent @keypress.native="control($event, 'n')" maxlength="15"></el-input>
                            </el-form-item>
                            <el-form-item label="Teféfono Celular" prop="Celular">
                                <el-input type="text" v-model="datospersonales.Celular" @paste.prevent @keypress.native="control($event, 'n')" maxlength="15"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" justify="space-between" style="width:100%; margin-top:30px">
                        <el-col :xs="24" :sm="12" :md="8" style="float:right; margin-bottom:10px; margin-top:-5px">
                            <v-btn 
                                raised 
                                block
                                color="blue" 
                                :loading="cargando" 
                                @click="DatosSubmit('fp')"
                                style="color:#fff"
                            >
                                Guardar Cambios
                            </v-btn>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" style="float:left">
                            <router-link class="el-col el-col-24 el-button el-button--danger"
                            :to="{ name: 'datos' }">
                                Volver
                            </router-link>
                        </el-col>
                    </el-row>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>


<script>
    import axios from 'axios';

    export default
    {   data()
        {   return {
                //Publicos
                Tipo:               this.$route.params.id,
                cargando:           false,
                estado:             false,
                error:              false,

                //Datos Personales
                datospersonales:    [],
                Localidades:        [],
                Provincias:         [],
                Sexos:              [],

                rules_fp: {
                    pre_cuil: [
                        { required: true, message: 'Por favor, ingrese su Pre CUIL', trigger: 'blur' }
                    ],
                    pos_cuil: [
                        { required: true, message: 'Por favor, ingrese su Pos CUIL', trigger: 'blur' }
                    ],
                    Apellido: [
                        { required: true, message: 'Por favor, ingrese su Apellido', trigger: 'blur' }
                    ],
                    Nombre: [
                        { required: true, message: 'Por favor, ingrese su Nombre', trigger: 'blur' }
                    ],
                    Nacimiento: [
                        { required: true, message: 'Por favor, ingrese su Fecha de Nacimiento', trigger: 'blur' },
                        { min: 10, max: 10, message: 'Fecha inválida', trigger: 'blur' }
                    ],
                    Sexo: [
                        { required: true, message: 'Por favor, seleccione un sexo', trigger: 'blur' }
                    ],
                    Localidad: [
                        { required: true, message: 'Por favor, seleccione una Localidad', trigger: 'blur' }
                    ],
                    Provincia: [
                        { required: true, message: 'Por favor, seleccione una Provincia', trigger: 'blur' }
                    ],
                    Titulo_profesional: [
                        { required: true, message: 'Por favor, ingrese su Título Profesional', trigger: 'blur' }
                    ],
                    Mail: [
                        { required: true, message: 'Por favor, ingrese su e-mail', trigger: 'blur' }
                    ],
                    Telefono: [
                        { min: 7, max: 15, message: 'Teléfono Inválido', trigger: 'blur' }
                    ],
                    Celular: [
                        { required: true, message: 'Por favor, ingrese su Celular', trigger: 'blur' },
                        { min: 10, max: 15, message: 'Teléfono Inválido. Mínimo 10 dígitos', trigger: 'blur' }
                    ], 
                },
            }
        },


        methods:
        {   control(e, tipo)
            {   if(tipo=='t')
                {   if( (e.which>32  && e.which<65)  ||
                        (e.which>90  && e.which<97)  ||
                        (e.which>123 && e.which<209) ||
                        (e.which>209 && e.which<241) ||
                        (e.which>241)
                    )
                    { e.preventDefault(); }                                                 // Campo alfabetico
                }
                if(tipo=='n')
                {   if( (e.which>31 & e.which<48) || e.which>57) { e.preventDefault(); }    // Campo numerico
                }
                if(tipo=='m')
                {   if( (e.which>32  && e.which<45)  ||
                        (e.which>46  && e.which<48)  ||
                        (e.which>57  && e.which<64)  ||
                        (e.which>90  && e.which<95)  ||
                        (e.which>95  && e.which<97)  ||
                        (e.which>123 && e.which<209) ||
                        (e.which>209 && e.which<241) ||
                        (e.which>241)
                    )
                    { e.preventDefault(); }                                                 // Mail 
                }
            },
            DatosSubmit(formName)
            {   this.$refs[formName].validate((valid) => {
                    if (valid)
                    {   this.cargando   = true;
                        this.estado     = false;
                        this.error      = false;

                        var params  = '';
                        var headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');

                        params  = params + '&tkn=' + this.$cookies.get('PDTK');
                        params  = params + '&DNI=' + this.datospersonales.DNI;
                        params  = params + '&pre_cuil=' + this.datospersonales.pre_cuil;
                        params  = params + '&pos_cuil=' + this.datospersonales.pos_cuil;
                        params  = params + '&Apellido=' + this.datospersonales.Apellido;
                        params  = params + '&Nombre=' + this.datospersonales.Nombre;
                        params  = params + '&Nacimiento=' + this.datospersonales.Nacimiento;
                        params  = params + '&Sexo=' + this.datospersonales.Sexo;
                        params  = params + '&Localidad=' + this.datospersonales.Localidad;
                        params  = params + '&Provincia=' + this.datospersonales.Provincia;
                        params  = params + '&Titulo_profesional=' + this.datospersonales.Titulo_profesional;
                        params  = params + '&Mail=' + this.datospersonales.Mail;
                        params  = params + '&Telefono=' + this.datospersonales.Telefono;
                        params  = params + '&Celular=' + this.datospersonales.Celular;
                        
                        axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/doc_pers_up.php', params, {headers: headers})
                            .then(response => {
                                const datos             = response.data
                                this.estado             = datos['estado'];
                                this.error              = datos['error'];
                                this.cargando           = false;
                                window.scrollTo(0,0);
                            })
                            .catch(e => {
                                this.error              = true;
                            })
                    }
                });
            }
        },


        beforeMount()
        {   if(!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
            else
            {   var params  = 'tkn=' + this.$cookies.get('PDTK');
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/doc.php', params, {headers: headers})
                    .then(response => {
                        const datos                     = response.data
                        this.datospersonales            = datos['personales'];
                        this.Localidades                = datos['Localidades'];
                        this.Provincias                 = datos['Provincias'];
                        this.Sexos                      = datos['Sexo'];
                    })
                  /*  .catch(e => {})*/
            }
        },


        mounted()
        {   this.$nextTick(this.$refs.Apellido.focus);
        }
    };
</script>
